import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'numberTwoDigits'
})
export class NumberTwoDigitsPipe implements PipeTransform {

  transform(value: number, args?: any): any {

    let resp: string = String(value);

    if (value < 10 && value > -10) {
      resp = '0' + value;
    }

    return resp;
  }

}



// WEBPACK FOOTER //
// /app/src/app/pipes/number-two-digits.pipe.ts